// NotaVenta
import DocumentoPage from "./DocumentoPage";

const NotaVenta = () => (
  <DocumentoPage
    title="Ingreso Nota de Venta"
    tipoDocumento="nota-venta"
    initialLoading={false}
    showFilter={true}
  />
);

export default NotaVenta;